/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SearchProductCondition;
(function (SearchProductCondition) {
    /**
     * operation applied between the values of the property. If not passed OR will be applied by default
     * Example:
     * 1. minLeadTime > 80 AND minLeadTime < 100
     * 2. minLeadTime = 10 OR minLeadTime = 20
     *
     */
    var logicalOperator;
    (function (logicalOperator) {
        logicalOperator["OR"] = "OR";
        logicalOperator["AND"] = "AND";
    })(logicalOperator = SearchProductCondition.logicalOperator || (SearchProductCondition.logicalOperator = {}));
})(SearchProductCondition || (SearchProductCondition = {}));
